<template>
    <div id="ModalClaimARStatusEdit">
         <b-modal size="xl" :id="ModalId" :visible="true" centered no-close-on-backdrop no-close-on-esc :title="TitleWindow" ref="modalcategory" @close="this.emitEventCancel" @ok="this.emitEventOK" @cancel="this.emitEventCancel" :cancel-title="$t('Shared.BtnCancel')"> 
            <MdSelect
                    v-bind:Label="$t('AR Status')"
                    v-bind:Options="ARStatusList"
                    v-bind:Model="ARStatus"
                    v-bind:FieldDescription="'description'"
                    v-bind:FieldCode="'code'"
                    v-bind:Multiple="false"                    
                    :Input="ChangeDropdownARStatus"
            />
            <MdMemo
                v-bind:Name="'arStatus'"
                v-bind:Rows="'5'"
                v-bind:MaxRows="'250'"       
                v-model="ARStatusTemplate" />
        </b-modal>
    </div>
</template>

<script>
import ClaimHistory from '@/services/claimhistory.service';
import ShowMessage from '@/components/messages/ShowMessage.js'
import LocalStorage from '@/services/storage.service'
import DBFunctions from '@/common/DBFunctions.js'
export default {
    name: "ClaimARStatusModalEdit",
    mixins: [ShowMessage, DBFunctions],
    props: {
        ModalId: String,
        TitleWindow: String,  
        ModelARStatus: String,
        ARStatusItems: {
            type: Array,
            default: () => []
        },
        ARStatusList: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            ARStatus: null,
            ARStatusTemplate: ''
        }
    },
    methods:{
        ChangeDropdownARStatus(item) {
            this.ARStatus = item ? item.code : "";
            this.ARStatusTemplate = item ? item.template : "";
          },
        emitEventCancel(){
            this.$emit('cancelAddStatus',true);
        },

        emitEventOK(){
                const bulkParams = this.ARStatusItems.map(item => ({
                    ...item,
                    Status: this.ARStatus,
                    SysUser: LocalStorage.getUserId(),
                    SysDate: new Date(),
                    Note: this.ARStatusTemplate
                }))
                ClaimHistory.bulkInsertHistory(bulkParams).then((response) => {
                    console.log(response.data)
                    this.$emit('confirmAddStatus',true);
                }).catch((error) => {
                    if (!error.response) {
                        // network error
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    } else {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                });
        },
    }
}
</script>